import { Service } from "@api/common";
import { RPCRequestBody } from "./types/rpc";

export class MarianaTekService extends Service<any> {
  constructor(id: string) {
    super(`/integrations/${id}`);
  }

  async fetch(body: RPCRequestBody): Promise<any> {
    return this.post(`${this.basePath}/rpc`, body);
  }
  async getLocations() {
    const response = await this.fetch({
      path: "/api/locations",
      method: "GET",
      searchParams: { page_size: "25" },
    });
    return new Promise((resolve) => {
      resolve(response.data);
    });
  }
  async getUser(id: string) {
    const response = await this.fetch({
      path: `/api/users/${id}`,
      method: "GET",
      searchParams: {
        include: "last_class_taken_date,top_location_name",
      },
    });
    return new Promise((resolve) => {
      resolve(response.data);
    });
  }
  async getUserMemberships(id: string) {
    const response = await this.fetch({
      path: `/api/membership_instances`,
      method: "GET",
      searchParams: {
        user: id,
        include: "membership,current_membership_transaction,events",
      },
    });
    const data = addIncludedObjectsToData(response);
    return new Promise((resolve) => {
      resolve(data);
    });
  }
  async getUserReservations(id: string) {
    const response = await this.fetch({
      path: `/api/reservations`,
      method: "GET",
      searchParams: {
        user_or_booked_on_behalf_of_user: id,
        // status: 'inactive,upcoming',
        include: "class_session,credit_transactions,membership_transactions,spot",
        ordering: "-class_session_start_datetime",
      },
    });
    const data = addIncludedObjectsToData(response);
    return new Promise((resolve) => {
      resolve(data);
    });
  }
}

// export const marianaTekService = new MarianaTekService(integrationId)
interface IncludedItem {
  type: string;
  id: string;
  attributes: any;
  relationships?: any;
}

interface DataItemBase {
  type: string;
  id: string;
  attributes: any;
  relationships?: any;
}

// Extending DataItemBase to include dynamic keys for included items
export interface EnhancedDataItem extends DataItemBase {
  [key: string]: any;
}

interface ApiResponse {
  meta: any;
  links: any;
  data: DataItemBase[];
  included: IncludedItem[];
}

function addIncludedObjectsToData(response: ApiResponse): EnhancedDataItem[] {
  const { data, included } = response;

  return data.map((dataItem) => {
    const enhancedDataItem: EnhancedDataItem = { ...dataItem };

    // Remove relationships key from the enhanced data item
    delete enhancedDataItem.relationships;

    Object.keys(dataItem.relationships || {}).forEach((key) => {
      const relationshipData = dataItem.relationships[key].data;

      if (Array.isArray(relationshipData)) {
        enhancedDataItem[key] = relationshipData
          .map((relItem) =>
            included.find(
              (incItem) => relItem && incItem.id === relItem.id && incItem.type === relItem.type,
            ),
          )
          .filter((item): item is IncludedItem => Boolean(item));
      } else if (relationshipData) {
        // Check if relationshipData is not null
        enhancedDataItem[key] = included.find(
          (incItem) => incItem.id === relationshipData.id && incItem.type === relationshipData.type,
        );
      } else {
        enhancedDataItem[key] = null; // Assign null if the relationship data is null
      }
    });

    return enhancedDataItem;
  });
}
